<script lang="ts">
	import { getContext } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { ButtonV2 } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import type { SidepanelStickyBottomProps } from '../sidepanel-types';

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');
</script>

{#if $stickyBottomAction}
	{@const action = $stickyBottomAction}
	{#if action.secondaryButton}
		<ButtonV2
			size="m"
			width="full"
			icon={action.secondaryButton.icon}
			disabled={action.secondaryButton.disabled}
			variant={action.secondaryButton.variant ?? 'secondary'}
			on:click={action.secondaryButton.onClick}
		>
			{action.secondaryButton.label}
		</ButtonV2>
	{/if}
	<ButtonV2
		size="m"
		width="full"
		icon={action.icon}
		class={action.secondaryButton ? `mt-${action.gap ?? 's'}` : ''}
		on:click={action.onClick}
		loading={action.loading}
		disabled={action.disabled}
	>
		{action.label ?? $format('button_save', { default: 'Save' })}
	</ButtonV2>
{/if}
